<template>
  <ModalBase :show-modal="true" @close-modal="close" :auto-h="true" class="dashboard-promo-modal">
    <template v-slot:maincontent>
      <div style="padding: 2rem; text-align: center;">
        <div style="margin-bottom: 2rem;">
          <img src="/static/images/bf2023-logo.png" alt="" style="width: 250px; margin: 0 auto; display: block;">
        </div>
        <div>
          <h1>{{ $gettext('THIS FRIDAY = BLACK FRIDAY') }}</h1>
          <h2 style="margin-bottom: 1rem;" v-html="getDiscountMessage" />

          <p style="font-size: 14px;" v-html="getMainMessage" />
          <!-- <p style="font-size: 16px;">
            {{ $gettext('This Friday new Premium users can take advantage of a special Black Friday discount on yearly subscriptions. The discount is very high and you need to upgrade between Thursday 12 PM and Friday 12 PM, to take advantage of this deal. So keep an eye on your account to get more details and make sure you do not miss it. You really only have 24 hours.') }}
          </p> -->
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton"
export default {
  name: 'PromoModal',
  components: {
    ModalBase, TitleBar, GekkoButton
  },
  props: {
    promoData: {
      type: Object,
      default: () => {}
    },
    showPrices: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    getEndDay(){
      var splitDays = this.promoData.discount.end_date.split("-");
      return splitDays[splitDays.length-1];
    },
    getMainMessage(){
      var message = this.$gettext('Offer only for current Basic users. Existing Premium users are not eligible. Offer only available on the {0}th for 24 hours until 12.00 PM. Discount only applies to Basic users upgrading to a yearly Premium account (additional users are excluded from offer).');
      message = message.replace("{0}", this.getEndDay);
      return message;
    },
    getDiscountMessage(){
      if(this.showPrices){
        var message = this.$gettext('{0},- discount to a yearly subscription Premium. More than {1}% off.');
        var percent = 0;
        var amount = 0;
        if(this.promoData.discount.benefit_type === "amount"){
          amount = this.promoData.discount.amount;
          percent = this.promoData.discount.amount/this.promoData.plan_cost_yearly * 100;
        }else{
          percent = this.promoData.discount.amount;
          amount = this.promoData.plan_cost_yearly * this.percent;
        }
        percent = Math.floor(percent/10)*10;
        message = message.replace("{0}", Math.floor(amount));
        message = message.replace("{1}", Math.floor(percent));
        return message;
      }else{
        return this.$gettext('24 hours of <span class=\'banner-price-tag\'>major discounts</span> on Premium')
      }
    }
  },
  mounted () {
    document.body.classList.add('modal-on');
  },
  methods: {
    close () {
      console.log('close modal')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  .dashboard-promo-modal {
    .gk-modal {
      padding: 0.5rem;
      max-width: 900px !important;
      .gk-modal-content {
        background: url('/static/images/bf2023-dash-banner-bg.png'), linear-gradient(103deg, rgb(234 23 50) 50%, rgb(94 18 24) 61%);
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        border-radius: $radiusMd;
        color: white;
        .modal-content-wrap { background: transparent; }
        .close-btn { top: 0; right: 0; }
      }
    }
  }
</style>
